import React from 'react';
import { Icon } from '@iconify/react';
import { HighlightedTextIcon } from 'components/molecules';
import { AboutSectionContentProps } from 'components/organisms/About/types';
import reactIcon from '@iconify/icons-logos/react';
import tailwindcssIcon from '@iconify/icons-logos/tailwindcss-icon';

const Text = () => (
    <>
        我使用 <HighlightedTextIcon
            as="a"
            href="https://reactjs.org"
            className="mx-2"
            icon={<Icon icon={reactIcon} />}
        >
            <span className="font-bold text-gray-800">React</span>
        </HighlightedTextIcon>
        {', '} <HighlightedTextIcon as="a" href="https://www.typescriptlang.org/" className="mx-2" icon={<img src="/img/typescript.svg" alt="TypeScript" className="w-5 h-5" />}>
            <span className="font-bold text-gray-800">TypeScript</span>
        </HighlightedTextIcon>，和 <HighlightedTextIcon as="a" href="https://supabase.com/" className="mx-2" icon={<img src="/img/supabase.svg" alt="Supabase" className="w-5 h-5" />}>
            <span className="font-bold text-gray-800">Supabase</span>
        </HighlightedTextIcon> 设计尖端的全栈 Web 解决方案。我的专长是为现代 Web 应用程序开发响应式用户界面和坚固的后端。我喜欢使用
        <HighlightedTextIcon
            as="a"
            href="https://reactjs.org"
            className="mx-2"
            icon={<Icon icon={reactIcon} />}
        >
            <span className="font-bold text-gray-800">React</span>
        </HighlightedTextIcon>
        {' '}和
        <HighlightedTextIcon
            as="a"
            href="https://tailwindcss.com"
            className="mx-2"
            icon={<Icon icon={tailwindcssIcon} />}
        >
            <span className="font-bold text-gray-800">TailwindCSS</span>
        </HighlightedTextIcon>
        {' '}和
        <HighlightedTextIcon
            as="a"
            href="https://ui.shadcn.com/"
            className="mx-2"
            icon={<img src="/img/shadcn.svg" alt="ShadCN" className="w-5 h-5" />}
        >
            <span className="font-bold text-gray-800">ShadCN/UI</span>
        </HighlightedTextIcon>
        构建生产级 Web 应用程序。

        {'. '}我也有使用
        <HighlightedTextIcon as="a" href="https://nextjs.org/" className="mx-2" icon={<img src="/img/nextjs.svg" alt="Next.js" className="w-5 h-5" />}>
            <span className="font-bold text-gray-800">Next.js</span>
        </HighlightedTextIcon> 构建 Web 应用程序的经验。我已经使用这些工具大约 <span className="font-bold text-gray-800">2 年</span> 了，我有信心使用它们构建应用程序。我在

        <HighlightedTextIcon as="a" href="https://weabers.com/" className="mx-2" icon={<img src="/img/weabers.avif" alt="Weabers" className="w-5 h-5" />}>
            <span className="font-bold text-gray-800">Weabers</span>
        </HighlightedTextIcon> 完成了 Web 开发人员的实习{'. '} 我也是一个 <HighlightedTextIcon as='a' href="https://www.sports.com" className="mx-2" icon={<img src="/img/sports.svg" alt="sports" className="w-5 h-5" />}>
            <span className="font-bold text-gray-800">体育爱好者</span>
        </HighlightedTextIcon> 和一个 <HighlightedTextIcon
            as='a'
            href="https://robocopplays.netlify.app/"
            className="mx-2"
            icon={<img src="/img/gamer.svg" alt="gamer" className="w-5 h-5" />}
        >
            <span className="font-bold text-gray-800">游戏玩家</span>
        </HighlightedTextIcon>。
    </>
);

const about: AboutSectionContentProps = {
    text: <Text />,
};

export default about;
